import { Type } from '@angular/core';

import { InternalContentComponentType } from '@ppg/core/enums';
import { InlineImageWrapperComponent } from '@ppg/shared/components';

export const INTERNAL_CONTENT_COMPONENTS_MAP = {
  [InternalContentComponentType.INLINE_IMAGE_WRAPPER_COMPONENT]: InlineImageWrapperComponent,
} satisfies { [key in InternalContentComponentType]?: Type<unknown> };
